import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { AppProviders } from './providers/app-providers';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('index.html is missing the #root element the application mounts into.');
}

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders />
  </StrictMode>,
);
